export const trading = {
    kpsj: "오픈 시간",
    jlks: "시작까지 남은 시간",
    t: "일",
    s: "시",
    f: "분",
    m: "초",

    zgj: "최고 가격:",
    zdj: "최저 가격:",
    gflj: "공식 링크",
    gw: "공식 웹사이트",
    qkllq: "블록 탐색기",
    scfxsj: "최초 발행 시간",
    fxzl: "총 발행량",
    ltzl: "유통량",
    jy: "거래",
    sj: "시가",
    tbxx: "차트 정보",
    bzgk: "토큰 개요",
    jcb: "기본",
    ddb: "주문서",
    zxcj: "최신 거래",

    reload: "새로 고침",
    socketError: "네트워크 오류,",
    noData: "데이터 없음",
    entrustorder: "주문서",
    prices: "가격",
    quantity: "수량",
    grandtotal: "총액",
    transamount: "거래액",
    time: "시간",
    available: "사용 가능",
    limitorder: "지정가",
    plancommission: "계획 주문",
    currentcommission: "주문",
    historycommission: "주문 기록",
    completecommission: "완료된 주문",
    funds: "자금",
    hidetrading: "다른 거래쌍 숨기기",
    morecurrentcommission: "현재 주문 더 보기",
    morehistorycommission: "과거 주문 더 보기",
    moredocommission: "처리된 주문 더 보기",
    realtimetrans: "실시간 거래",
    myassets: "내 자산",
    detail: "세부 정보",
    buyin: "매수",
    sellout: "매도",
    login: "로그인",
    transfer: "이체",
    recharge: "입금",
    withdrawal: "출금",
    quickpurchase: "파이어트 즉시 구매",
    default: "기본",
    ordertime: "주문 시간",
    tradingpair: "거래쌍",
    direction: "방향",
    types: "유형",
    commissionprice: "주문 가격",
    commissionnumber: "주문 수량",
    dealprice: "평균 거래가",
    dealnumber: "거래 수량",
    triggerprice: "트리거 가격",
    cancelall: "모두 취소",
    averageprice: "평균 가격",
    totalsum: "총액",
    fixedprice: "지정가",
    marketprice: "시장가",
    codeExpired: "QR 코드 만료됨",
    clickRefresh: "새로 고침 클릭",
    QRsuccessfully: "QR 코드 스캔 완료",
    loginInApp: "앱 내에서 로그인 확인하세요",
    backtoQR: "QR 코드 로그인으로 돌아가기",
    loginSuccess: "로그인 성공, biking에 오신 것을 환영합니다!",
    loadingText: "로딩 중...",
    searchPlaceholder: "검색",
    all: "모두",
    currency: "통화",
    price: "최신 가격",
    market: "시가",
    increase: "상승률",
    highestPrice: "최고 가격",
    minimumPrice: "최저 가격",
    turnover: "거래량",
    jydlb: "거래쌍 목록",
    bzjs: "토큰 소개",
    currencyTransaction: "통화 거래",
    leveragedTransaction: "레버리지 거래",
    warning:
    "위험 경고: Bitcoin Cash 분기는 매우 불확실성이 높으며, 분기 선물 토큰 거래 또는 투자는 매우 높은 위험을 내포하며, 특정 체인에 광부 지원이 부족할 경우 지속될 수 없으며, 보유하고 있는 관련 토큰은 제로화 위험이 있습니다. BiKing은 어떤 분기 선물 토큰의 가치에 대해 어떤 약속도 하지 않습니다!",
    zb: "지표",
    date: "날짜",
    UpAnddown: "상승 및 하락",
    amplitude: "진폭",
    0: "분봉",
    1: "1분봉",
    5: "5분봉",
    15: "15분봉",
    30: "30분봉",
    60: "1시간봉",
    240: "4시간봉",
    3600: "일봉",
    10800: "주봉",
    dates: "주기:",
    password: "거래 비밀번호",
    errorPassword: "올바른 거래 비밀번호를 입력하세요",
    worningPassword: "거래 비밀번호를 입력하세요",
    cancel: "취소",
    sure: "확인",
    canBuy: "구매 가능",
    canCell: "판매 가능",
    withdraw: "출금",
    otc: "OTC, 파이어트 빠른 입출금",
    enterPrice: "가격을 입력하세요",
    sellingPrice: "판매 가격",
    purchasePrice: "구매 가격",
    salesVolume: "판매량",
    buyingVolume: "구매량",
    volume: "거래액",
    serviceCharge: "수수료",
    vip: "VIP 등급 업그레이드, 수수료 할인 적용",
    or: "또는",
    register: "등록",
    totalPrice: "거래액은",
    amountTip: "올바른 수량을 입력하세요",
    amountTipError: "수량은",
    limitTrading: "지정가 거래",
    priceReminder: "가격 알림",
    SMSReminder: "문자 메시지 알림",
    loginAccount: "로그인 계정",
    phone: "휴대폰",
    phoneNum: "휴대폰 번호를 입력하세요",
    phoneTips: "올바른 휴대폰 번호를 입력하세요",
    email: "이메일",
    emailNum: "이메일을 입력하세요",
    emailTips: "올바른 이메일을 입력하세요",
    aears: "지역 코드를 선택하세요",
    passwordError: "올바른 비밀번호를 입력하세요",
    passwordTips: "비밀번호를 입력하세요",
    forgetPassword: "비밀번호를 잊으셨나요",
    noAccount: "계정이 없으신가요",
    goRegister: "지금 등록하세요",
    appsys: "앱을 스캔하여 안전하게 로그인하세요",
    xzapp: "최신 앱 다운로드",
    mmdl: "비밀번호 로그인",
    smdl: "QR 코드 로그인",
    google: "구글 인증기",
    nybd: "당신은 이미 연결되어 있습니다",
    zqyzm: "올바른 코드를 입력하세요",
    fsyzm: "코드 보내기",
    flv: "비율",
    jz: "순자산 가치",
    jzdesc1:
    "금매 순자산 가치 = 직전 조정 시점의 순자산 가치*[1+3*(현물 최신 거래가격-현물 직전 조정 시점 가격)/현물 직전 조정 시점 가격100%]；",
    jzdesc2:
    "평매 순자산 가치 = 직전 조정 시점의 순자산 가치[1-3*(현물 최신 거래가격-현물 직전 조정 시점 가격)/현물 직전 조정 시점 가격100%]；",
    sbd: "3배 매수",
    sbs: "3배 매도",
    flvjs:
    'ETF 자금 비율은 플랫폼이 매일 레버리지에 대한 관리 수수료를 공제하여 기금 조합에서 발생하는 자금 비율을 지불하기 위해 수집됩니다. 수수료는 순자산의 변화에 반영되며, 즉 "해당 레버리지 ETF의 가치를 차감하는" 방식으로 나타나며, 싱가포르 시간 0시에만 부과되며, 해당 시간에 상품을 보유하지 않으면 요금이 발생하지 않습니다.',
    mzsm: "면책 조항",
    ido: "다음을 읽고 동의했습니다",
    exemption1: "고객님, 안녕하세요!",
    exemption2:
    "BiKing 플랫폼 (BiKing.ai)에서 제공하는 ETF 제품 및 관련 서비스 (이하 'ETF 제품'이라 함)을 사용하여 로그인하고 사용해 주셔서 감사합니다. 다음에 안내 드리는 ETF 제품 설명과 위험 경고를 주의 깊게 읽어 주시기 바랍니다. 본인이 읽은 후에도 ETF 제품을 계속 사용하면 ETF 제품의 위험을 완전히 이해하고 이를 감수할 수 있으며 본 면책서의 모든 내용에 동의하는 것으로 간주됩니다. ETF 제품 설명서를 읽으려면 여기를 클릭하세요:",
    exemption3: "《레버리지 ETF 제품 FAQ》",
    exemption4: "위험 경고:",
    exemption5:
    "1. 구매/판매한 가격이 단위 순자산 가치와 크게 차이나지 않아야 하며, 그렇지 않으면 해당 손실이 발생합니다.",
    exemption6: "2. 방향 판단이 잘못된 경우 극단적인 시장 상황에서 가격이 거의 제로에 가까워질 위험이 있습니다.",
    exemption7:
    "BiKing 플랫폼은 위에 언급된 위험으로 인한 손실 또는 책임에 대해 어떤 책임도 지지 않으며, 해당 면책 성명서는 BiKing 플랫폼 서비스 및 제품에 대한 고객과 BiKing 플랫폼 간의 모든 합의 사항으로 간주됩니다.",
    bzjs1: "1. '3L'은 기초 거래쌍의 가격이 1% 상승할 때 제품 순자산 가치가 3% 상승함을 의미합니다.",
    bzjs2: "2. '3S'는 기초 거래쌍의 가격이 1% 하락할 때 제품 순자산 가치가 3% 상승함을 의미합니다.",
    bzjs3: "3. 순자산 가치는 정상적으로 매일 0시에 조정되며, 극단적인 시장 상황에서는 거래 중에 조정됩니다.",
    bzjs4: "4. 각 레버리지마다 일일 수수료가 부과됩니다.",
    bzjs5:
    "5. 거래 전에 순자산 가치를주의 깊게 살펴보세요. 제품은 극단적인 시장 상황에서 제로에 가까워질 위험이 있으며, 가격이 순자산 가치에서 크게 벗어나는 경우 투자자는 위험을 조절하는 데 주의해야 합니다.",
    gdjk: "공고를 더 찾아보려면",
    firstTrading: "거래를 시작하기 전에 먼저 거래 비밀번호를 설정하세요",
    status: "상태",
    status1: "매칭 대기 중",
    status2: "미체결",
    status3: "사용자 취소",
    status4: "일부 체결됨",
    status5: "전부 체결됨",
    status6: "무효",
    allCancel: "모든 주문서 일괄 취소",
    canceld: "취소됨",
    cancelsuccess: "모든 주문서가 성공적으로 취소되었습니다. []개 주문이 취소되었습니다",
    VIP1: "귀하의 VIP 등급",
    VIP2: "더 저렴한 거래 수수료, 더 좋은 거래 경험",
    VIP3: "Taker(체결자):",
    VIP4: "Maker(주문자):",
    buyAmount: "구매 수량은",
    sellAmount: "판매 수량은",
    buyAmountMin: "사용 가능한 구매 잔액이 부족합니다",
    sellAmountMin: "사용 가능한 판매 잔액이 부족합니다",
  
  };
  


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/kr.js